import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  FormText,
  Row,
  Col,
  Table
} from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import Switch from "react-bootstrap-switch";
import profileImg from "assets/upload/profile.png";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import axios from "axios";
import {base_api_url} from "variables/general.js";
import $ from "jquery";
import swal from 'sweetalert';

function getData() {

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  let urlTarget = base_api_url + '/api/v1/notification/getnotificationbyid?notificationId=' + params.id; 
  return axios.get(urlTarget).then(res => {
    let datas = res.data.response;
    showData(datas);
  })
}

function showData(data) {
  $("#message").html(data.message);
  $("#from").html(data.submittersname);
  $("#to").html(data.receiversrole);
  $("#subject").html(data.reason);
  $("#br_subject").html(data.reason);

  if (data.formtype) {

    if (data.formtype=="Activity Permission Form") {
      $(".viewform_link").attr("href",window.location.origin + "/admin/report/standard-report/activity-permission-form/" + data.fkformid + "?id=" + data.fkformid);
    } else if (data.formtype=="Travel Permission Form") {
      $(".viewform_link").attr("href",window.location.origin + "/admin/report/standard-report/travel-permission-form/" + data.fkformid + "?id=" + data.fkformid);
    } else if (data.formtype=="agentdetails") {
      $(".viewform_link").attr("href",window.location.origin + "/admin/agent/" + data.fkformid + "?id=" + data.fkformid);
    } else if (data.formtype=="hfregistration" || data.formtype=="hostfamilydetails") {
      $(".viewform_link").attr("href",window.location.origin + "/admin/submission/host-family/" + data.id + "?id=" + data.id + "&formid=" + data.fkformid);
    } else if (data.formtype=="coorddetails") {
      $(".viewform_link").attr("href",window.location.origin + "/admin/coordinator/" + data.id + "?id=" + data.id + "&formid=" + data.fkformid);
    } else if (data.formtype=="schoolbyCoord") {
      $(".viewform_link").attr("href",window.location.origin + "/admin/submission/school/" + data.id + "?id=" + data.id + "&formid=" + data.fkformid);
    } else if (data.formtype=="studentdetails") {
      $(".viewform_link").attr("href",window.location.origin + "/admin/submission/student/" + data.id + "?id=" + data.id + "&formid=" + data.fkformid);
    } else if (data.formtype=="coordStudentLogs") {
      $(".viewform_link").attr("href",window.location.origin + "/admin/report/standard-report/student-logs/" + data.fkformid + "?id=" + data.fkformid);
    } else if (data.formtype=="coordSchoolLogs") {
      $(".viewform_link").attr("href",window.location.origin + "/admin/report/standard-report/school-logs/" + data.fkformid + "?id=" + data.fkformid);
    } else if (data.formtype=="mstudentLogs") {
      $(".viewform_link").attr("href",window.location.origin + "/admin/report/standard-report/student-note/" + data.fkformid + "?id=" + data.fkformid);
    } else if (data.formtype=="mhostfamilyLogs") {
        $(".viewform_link").attr("href",window.location.origin + "/admin/report/standard-report/host-family-note/" + data.fkformid + "?id=" + data.fkformid);
    } else {
      $(".viewform_link").attr("href",window.location.origin + "/admin/report/standard-report/photograpic/" + data.fkformid);
    }
    $("#section_v_f").show();
  } else {
    $("#section_v_f").hide();
  }

  if (data.isread==false) {
    data["isread"] = true;
    axios.put(base_api_url + "/api/v1/notification/updatebynotificationid", data).then(res => {
      if (res.data=="OK"){
        //
      }
    }).catch(function (error) {
      swal("Failed!", "Something went wrong!", "error");
    });
  }

  if (data.timestamp) {
    let rd = new Date(data.timestamp);

    rd = rd.toUTCString();
    $("#timestamp").html(rd);
  }
}

class NotificationDetail extends React.Component {

  componentDidMount(){
    getData()

    $(".navbar-brand").html("Notification Detail");
  }

  render(){
    const currentDate = new Date();
    return (
    <>
      <PanelHeader size="sm"
        content={
          <div className="content">
            <div className="header text-left">
              <span className="panelHeaderDesc">View and manage your Notifications.</span>
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><a href="/admin/overview">Dashboard</a></li>
                  <li className="breadcrumb-item"><a href="/admin/notifications">Notifications</a></li>
                  <li className="breadcrumb-item active" aria-current="page" id="br_subject"></li>
                </ol>
              </nav>
            </div>
          </div>
        }
      />
      <br/>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4" className="text-header-notif" id="subject"></CardTitle>
                <a style={{float:"right", height:"30px"}} className="now-ui-icons cs-cancel_yellow" href="/admin/notifications" />
                <h4 style={{"fontFamily": "Noto Sans","fontStyle": "normal","fontWeight": 400,"fontSize": "16px","lineHeight": "24px","color": "#70B2D8"}} id="timestamp">{currentDate.toUTCString()}</h4>
              </CardHeader>
              <CardBody>
                <Form action="/" className="form-horizontal" method="get">
                  <hr/>
                  <Row className="text-header-info-notif">
                    <Col sm="12">
                      <Row>
                        <Col md="2">
                          <FormGroup>
                            <label htmlFor="pwd">From : <span id="from"></span></label>
                          </FormGroup>
                        </Col>
                        <Col md="10">
                          <FormGroup>
                            <label htmlFor="pwd">Receipent: <span id="to"></span></label>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <hr/>
    
                  <Row>
                    <Col sm="12">
                      <Row className="text-desc-notif">
                        <Col md="12">
                          <FormGroup>
                            <p>RE: <span id="subject"></span></p>
                            <p id="message"></p>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row id="section_v_f">
                    <Col sm="12">
                      <div className="pull-left">
                      	<a style={{"background":"#416D86"}} className="btn viewform_link btn-csconfirm">View Form</a>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
              <br/>
            </Card>
          </Col>
        </Row>
    
      </div>
    </>
  );
  }
}

export default NotificationDetail;
